module.exports = __webpack_public_path__ + "static/img/second2.a0b8ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/second2.png
// module id = N9qa
// module chunks = 25